export { OneThirdBanner } from './one-third-banner';
